import React from 'react';
import { Form, Input, Radio, Icon, Button, Checkbox, DatePicker, Select, Row, Col } from 'antd';
/*
import FormComponent from '../../../components/FormComponent';

class ContactFormSchool extends FormComponent{
  render(){
    return(
      <div>
        <Field {...fields.sub_type} options={{initialValue:'school'}}>
          <Radio.Group onChange={this.selectSubtype}>
            {fields.sub_type.items.map(item => (
              <Radio.Button value={item.value} key={item.value}><Icon type={item.icon}/> {item.label}</Radio.Button>
            ))}
          </Radio.Group>
        </Field>

        {props.subtype == 'visa' &&
        <Row>
          <Col sm={12} xs={24}>
            <Field {...fields.counselling_date}>
              <DatePicker />
            </Field>
          </Col>
          <Col sm={12} xs={24}>
            <Field {...fields.counselling_time}>
              <Select>
                {fields.counselling_time.items.map(item => (
                  <Select.Option value={item.key} key={item.key}>{item.label}</Select.Option>
                ))}
              </Select>
            </Field>
          </Col>
        </Row>
        }
      </div>
    )
  }
}

export const FormPluginSchool = (props) => {
  return(
  <div>
    <Field {...fields.sub_type} options={{initialValue:'school'}}>
      <Radio.Group onChange={this.selectSubtype}>
        {fields.sub_type.items.map(item => (
          <Radio.Button value={item.value} key={item.value}><Icon type={item.icon}/> {item.label}</Radio.Button>
        ))}
      </Radio.Group>
    </Field>

    {props.subtype == 'visa' &&
    <Row>
      <Col sm={12} xs={24}>
        <Field {...fields.counselling_date}>
          <DatePicker />
        </Field>
      </Col>
      <Col sm={12} xs={24}>
        <Field {...fields.counselling_time}>
          <Select>
            {fields.counselling_time.items.map(item => (
              <Select.Option value={item.key} key={item.key}>{item.label}</Select.Option>
            ))}
          </Select>
        </Field>
      </Col>
    </Row>
    }
  </div>
  )
}
*/



// WEBPACK FOOTER //
// ./src/pages/contact/components/ContactFormSchool.js